export async function fetchHomeOverview() {
  const res = await fetch("/api/home/");
  if (!res.ok) {
    throw new Error("Failed to load home overview.");
  }
  return res.json();
}
